import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const ErrorPage = ({ route: { status } }) => (
  <div className="flex flex-column flex-align-center text-align-center">
    <span className="icon dls-icon-warning dls-color-warning" />
    <div>
      <h4 className="dls-gray-05 heading-4 margin-1-tb">
        {
            status === 404
              ? <FormattedMessage id="page.not.found.title" />
              : <FormattedMessage id="loading.error.title" />
          }
      </h4>
      <p className="dls-body-3">
        {
            status === 404
              ? <FormattedMessage id="page.not.found.description" />
              : <FormattedMessage id="loading.error.description" />
          }
      </p>
    </div>
  </div>
);

ErrorPage.propTypes = {
  route: PropTypes.shape({
    status: PropTypes.number,
  }).isRequired,
};

export default ErrorPage;
